import React from "react";
import { RecoverPassword } from "elentari";
import { recoverPassword } from "../../services/Api";

export default function CustomRecoverPassword({ history }) {
  const handleSubmit = async ({ username }) => {
    const response = await recoverPassword({
      email: username,
    });
    if (response.ok) {
      return Promise.resolve({
        ok: true,
        message: "Email enviado, verifique sua caixa de entrada",
      });
    }
    return { ok: false, message: "Email inválido" };
  };

  return (
    <RecoverPassword
      history={history}
      usernameLabel="Email"
      backLabel="Voltar"
      submitLabel="Recuperar"
      onBackClick={() => history.goBack()}
      onSubmit={handleSubmit}
    />
  );
}
